module.exports = __webpack_public_path__ + "img/two.8aeebd2f.png";